var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9873 6.17467C4.73805 2.72467 5.61343 1 7 1C8.38657 1 9.26195 2.72467 11.0127 6.17467L11.2311 6.604C12.6861 9.47067 13.4138 10.904 12.7563 11.952C12.0987 13 10.4715 13 7.2184 13H6.78161C3.52848 13 1.90132 13 1.24374 11.952C0.586154 10.904 1.31394 9.47067 2.7689 6.604L2.9873 6.17467Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.33203V7.66536",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99842 10.3333C7.32979 10.3333 7.59841 10.0349 7.59841 9.66667C7.59841 9.29848 7.32979 9 6.99842 9C6.66706 9 6.39844 9.29848 6.39844 9.66667C6.39844 10.0349 6.66706 10.3333 6.99842 10.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnIcon);
export default __webpack_public_path__ + "static/media/WarnIcon.5dfc095598f088a4d17f8e4fab47a02d.svg";
export { ForwardRef as ReactComponent };